import { Component, Inject } from '@angular/core';

import { AccesListeGenericComponentBase } from './acces-liste-generic.component-base';
import { AccesSearchResult } from '../entities/acces-search-result';

import { JSR310ConversionService } from '../../../../shared/jsr310-localdates/services/jsr310-conversion.service';
import { EventBusService } from '../../../../technical-modules/events/services/event-bus.service';

import { AccesService } from '../services/acces.service';

type ColorMap = {
	[etat: string]: string,
}

@Component({
	selector: 'acces-liste',
	templateUrl: 'acces-liste.html',
	styleUrls: ['acces-liste.css'],
})
export class AccesListeComponent extends AccesListeGenericComponentBase<AccesSearchResult> {
	etatRappelColors: ColorMap = {
		'OUI': '#449d44',
		'NON': '#E10019',
		'MESSAGERIE': '#FFC300',
	};
	
	constructor(
		@Inject(JSR310ConversionService) jsr310Service: JSR310ConversionService,
		@Inject(EventBusService) eventBusService: EventBusService,
		@Inject(AccesService) accesService: AccesService,
	) {
		super(
			jsr310Service,
			eventBusService,
			accesService,
		);
	}
}